import { CompanySwitcher } from './CompanySwitcher';
import { StatusPill } from './StatusPill';

/** Mobile/tablet top app bar: company name and the two status pills. */
export function TopBar() {
  return (
    <header className="top-bar">
      <CompanySwitcher compact={false} inline />
      <div className="top-bar-pills">
        <StatusPill kind="drive" compact />
        <StatusPill kind="ai" compact />
      </div>
    </header>
  );
}
